import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { ENV_CONFIG, EnvironmentConfig } from 'src/environments/environment.model';
import { EquipmentFilter, EquipmentProduct, EquipmentTapInformation } from '../models/equipment.model';
import { ODataParams, ODataResponse, odataParamsFactory } from '../models/odata-response.model';

@Injectable({
  providedIn: 'root'
})
export class EquipmentService {
  url: string;
  version: string;

  constructor(
    private http: HttpClient,
    @Inject(ENV_CONFIG) private config: EnvironmentConfig) {
    this.url = this.config.endpoints.baseApi.url;
    this.version = this.config.endpoints.baseApi.version;
  }

  loadHotTapSizes(): Observable<number[]> {
    // I'm going to grab these from odata endpoint and then get the distinct values and provide object with imperial & metric
    return this.http.get<ODataResponse<EquipmentTapInformation[]>>(`${this.url}odata/${this.version}/EquipmentTapInformations?$select=nominalSize`)
      .pipe(
        map(sizes => {
          const s = (sizes.value || []).map(s => s.nominalSize)
            .filter((v, i, a) => a.indexOf(v) === i);
          console.log(s)
          return s;
        }));
  }

  loadEquipmentProducts(q: ODataParams): Observable<ODataResponse<EquipmentProduct[]>> {
    return this.http.get<ODataResponse<EquipmentProduct[]>>(`${this.url}odata/${this.version}/EquipmentProducts${q.toQuery()}`);
  }

  loadTapInformation(filter?: EquipmentFilter): Observable<ODataResponse<EquipmentTapInformation[]>> {
    let filterString = '';
    if (filter?.application === 'Standard Hot Tap') filterString = filterString + `StandardCutterPartNumber ne null `;
    if (filter?.application === 'SHORTSTOPP® Hot Tap') filterString = filterString + `ShortStoppCutterPartNumber ne null `;
    if (filter?.application === 'STOPPLE® Hot Tap') filterString = filterString + `StoppleCutterPartNumber ne null `;

    if (filter?.tapSize) filterString = `AND NominalSize eq ${filter.tapSize} `;
    if (filter?.tappingMachine) filterString = `AND TappingMachinePartNumber eq '${filter.tappingMachine}' `;

    if (filterString.startsWith('AND')) filterString = filterString.substring(3);
    const q = odataParamsFactory({
      filter: filterString,
      expand: 'TappingMachine($select=partNumber,productName),CutterHolder($select=partNumber,productName),Pilot($select=partNumber,productName),PilotCutter($select=partNumber,productName),Drill($select=partNumber,productName),HoleSaw($select=partNumber,productName),ShortStoppCutter($select=partNumber,productName),StandardCutter($select=partNumber,productName),StoppleCutter($select=partNumber,productName)',
      count: true
    })

    return this.http.get<ODataResponse<EquipmentTapInformation[]>>(`${this.url}odata/${this.version}/EquipmentTapInformations${q.toQuery()}`)
  }


}
